/* import __COLOCATED_TEMPLATE__ from './display-text.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */

import templateOnly from '@ember/component/template-only';
const PulseCandidateDisplayTextComponent = templateOnly();
export default PulseCandidateDisplayTextComponent;